<template>
  <div>
    <div class="settings relative">
      <div class="btn-wrapper mb-10  move-right">
        <transition name="fade" mode="out-in">
          <button
            @click.prevent="deleteAllLeaves"
            v-if="showDeleteButton"
            class="btn-back mr-15"
          >
            <img src="/img/delete-1.svg" alt="delete" class="mr-5" />
            <span>Delete items</span>
          </button>
        </transition>
        <router-link
          to="/admin/hrm/leave/create"
          class="btn btn-blue btn-full-radius inline-flex flex-v-end"
          v-if="allLeavesData.length"
        >
          <span> + New Leave</span>
        </router-link>
      </div>
      <div class="grid-full flex flex-h-bet">
        <div class="flex table-tab">
          <router-link class="table-tab-item" to="/admin/hrm/leave/all"
            >All Leaves</router-link
          >
        </div>
        <router-link
          to="/admin/hrm/leave/settings"
          class="move-right grid-full no-line"
        >
          <div class="settings-bg">
            <img src="/img/settings-b.svg" alt="settings" />
            <span>Settings</span>
          </div>
        </router-link>
      </div>
    </div>
    <div class="relative  adjust-height">
      <div class="relative inner-table">
        <div :class="{ overlay: true, show: view }"></div>
        <div class="table-heading flex flex-v-center flex-h-bet">
          <div class="media-group flex">
            <div class="filter-label filter"><p class="ml-10">Filter:</p></div>
            <el-date-picker
              v-model="filterDate"
              type="daterange"
              range-separator="To"
              start-placeholder="Start date"
              end-placeholder="End date"
              format="dd-MM-yyyy"
              value-format="yyyy-MM-dd"
              @change="getAllLeaves"
              class="no-border"
            >
            </el-date-picker>
            <el-select
              v-model="filterValue"
              placeholder="All Status"
              class="filter-select"
              clearable
              @change="getAllLeaves"
            >
              <el-option-group
                v-for="group in filterOptions"
                :key="group.label"
                :label="group.label"
              >
                <el-option
                  v-for="item in group.options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-option-group>
            </el-select>
            <el-select
              v-model="filterLeaveTypes"
              placeholder="Leave Type"
              class="filter-select"
              @change="getAllLeaves"
              clearable
            >
              <el-option
                v-for="item in leaveTypes"
                :key="item.id"
                :label="item.leave_name"
                :value="item.id"
              ></el-option>
            </el-select>
          </div>
          <div class="relative">
            <img
              src="/img/search-icon.svg"
              alt="search team table"
              class="search-icon"
            />
            <el-input
              placeholder="Search"
              name="search"
              type="text"
              class="short mr-10"
              v-model="searchQuery"
              @input="search"
              clearable
            ></el-input>
          </div>
        </div>
        <AllLeavesTable
          @toggleView="toggleView"
          @handleSelectionChange="handleSelectionChange"
          :overlayLoading="overlayLoading"
          @resetTable="resetTable"
          :filterValue="filterValue"
          :filterLeaveTypes="filterLeaveTypes"
          :searchQuery="searchQuery"
          :filterDate="filterDate"
          :data="allLeavesData"
        />
        <AllLeavesDetails :show="show" @toggleView="toggleView" />
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import AllLeavesTable from "../components/AllLeavesTable";
import AllLeavesDetails from "../components/AllLeavesDetails";
import debounce from "lodash.debounce";

const { mapState, mapActions } = createNamespacedHelpers("admin/hrm/leave");

export default {
  components: {
    AllLeavesTable,
    AllLeavesDetails,
  },
  data() {
    return {
      show: false,
      loading: false,
      overlayLoading: false,
      multipleSelection: [],
      filterOptions: [
        {
          label: "Status",
          options: [
            {
              label: "Scheduled",
              value: "scheduled",
            },
            {
              label: "Rejected",
              value: "rejected",
            },
            {
              label: "Pending",
              value: "pending",
            },
            {
              label: "Taken",
              value: "taken",
            },
            {
              label: "Cancelled",
              value: "cancelled",
            },
          ],
        },
      ],
    };
  },
  mounted() {
    this.fetchLeaveTypes();
  },
  computed: {
    ...mapState({
      view: "showViewContainer",
      leaveData: "currentLeave",
      employees: "Employees",
      leaveTypes: "leaveTypesSearch",
      allLeavesData: "leavesData",
    }),
    showDeleteButton() {
      return this.multipleSelection.length > 1;
    },
    searchQuery: {
      get() {
        return this.$store.state.admin.hrm.leave.searchQuery;
      },
      set(value) {
        return this.$store.commit("admin/hrm/leave/searchQuery", value);
      },
    },
    filterValue: {
      get() {
        return this.$store.state.admin.hrm.leave.filterValue;
      },
      set(value) {
        return this.$store.commit("admin/hrm/leave/filterValue", value);
      },
    },
    filterLeaveTypes: {
      get() {
        return this.$store.state.admin.hrm.leave.filterLeaveTypes;
      },
      set(value) {
        return this.$store.commit("admin/hrm/leave/filterLeaveTypes", value);
      },
    },
    filterDate: {
      get() {
        return this.$store.state.admin.hrm.leave.filterDate;
      },
      set(value) {
        return this.$store.commit("admin/hrm/leave/filterDate", value);
      },
    },
  },
  methods: {
    ...mapActions([
      "getAllLeaves",
      "deleteLeaves",
      "getLeaveById",
      "fetchLeaveTypes",
    ]),
    resetTable() {
      this.filterDate = "";
      this.filterLeaveTypes = "";
      this.searchQuery = "";
      this.filterValue = "";
      this.getAllLeaves();
    },
    deleteAllLeaves() {
      const selectedLeaves = this.multipleSelection.map(x => x.id);
      this.$promptModal(
        "Delete Leaves",
        "This leaves will be deleted",
        "Delete",
        () => this.handleDeleteLeaves(selectedLeaves)
      );
    },
    handleDeleteLeaves(ids) {
      this.loading = true;
      this.deleteLeaves(ids)
        .then(() => {
          this.loading = false;
          this.getAllLeaves();
        })
        .catch(error => {
          this.loading = false;
          this.$notification.error(error.message);
        });
    },
    search: debounce(function() {
      this.getAllLeaves();
    }, 500),
    toggleWhatToShow(what) {
      this.whatToShow = what;
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    toggleView(row) {
      if (!row) {
        this.show = false;
        return;
      }
      this.overlayLoading = true;
      this.getLeaveById(row.id)
        .then(response => {
          this.currentLeave = response;
          this.show = !this.show;
          this.overlayLoading = false;
        })
        .catch(() => {
          this.show = false;
          this.overlayLoading = false;
        });
    },
  },
};
</script>
<style scoped>
.el-range-editor.el-input__inner,
.el-date-editor .el-range-input,
.el-date-editor .el-range-separator {
  background-color: #fafafa !important;
}

.filter {
  background-color: #f6f6f6;
  padding: 10px;
  margin-right: 0px;
}
</style>
